import React, { memo } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isEmpty } from 'lodash-es';

import { everyChildrenChecked, someChildrenChecked, getSelectedOptions } from '../utils';
import SimpleCheckbox from '../../Checkbox/SimpleCheckbox';

const SelectorList = ({
  options,
  opened,
  selected,
  depth, // for depth-tracking
  className,
  onOpenItemsChange,
  onSelectionChange,
}) => {
  const handleSelectionChange = (checked, value, children) => {
    const nextSelection = getSelectedOptions(checked, value, children, selected);
    onSelectionChange(nextSelection);
  };

  const handleOpenItemsChange = (isOpen, value) => {
    const nextOpenedState = !isOpen ? [...opened, value] : opened.filter((item) => item !== value);
    onOpenItemsChange(nextOpenedState);
  };

  return (
    <div className={cx('nested-selector-list', depth && `nested-list-${depth}`, className)}>
      {options.map(({ value, text, children }) => {
        const hasChildren = !isEmpty(children);
        let isChecked = selected.includes(value);
        let isIntermediateChecked;
        let isOpen;

        if (hasChildren) {
          isChecked = someChildrenChecked(children, selected);
          isIntermediateChecked = isChecked && !everyChildrenChecked(children, selected);
          isOpen = opened.includes(value);
        }

        return (
          <div key={value} className="nested-selector-list-item">
            <div className="nested-selector-list-item-head">
              {hasChildren && (
                <span
                  className={cx('hicon-angle-down', !isOpen && 'collapsed')}
                  onClick={() => handleOpenItemsChange(isOpen, value)}
                />
              )}
              <SimpleCheckbox
                id={`nested-list-item-${value}`}
                label={text}
                checked={isChecked}
                indeterminate={isIntermediateChecked}
                gap="10px"
                size="lg"
                onChange={(checked) => handleSelectionChange(checked, value, children)}
              />
            </div>
            {hasChildren && (
              <SelectorList
                options={children}
                opened={opened}
                selected={selected}
                depth={(depth || 0) + 1}
                className={!isOpen ? 'collapsed' : ''}
                onOpenItemsChange={onOpenItemsChange}
                onSelectionChange={onSelectionChange}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

SelectorList.propTypes = {
  options: T.array.isRequired,
  opened: T.array.isRequired,
  selected: T.array.isRequired,
  depth: T.number,
  className: T.string,
  onOpenItemsChange: T.func.isRequired,
  onSelectionChange: T.func.isRequired,
};

export default memo(SelectorList);
